import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SelectGroup from '../form/select-group';
import { timezones } from '../../util';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            timezone: {
                value: props.user.timezone,
                error: false,
            },
        };
    }

    render() {
        return (
            <time-zone>
                <row className='is-wrap'>
                    <column className='is-6 is-12-mobile'>
                        <SelectGroup
                            name='timezone'
                            value={this.state.timezone.value}
                            placeholder='SELECT TIME ZONE'
                            options={timezones}
                            error={this.state.timezone.error}
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            </time-zone>
        );
    }

    handleChange = (e) => {
        const state = {
            [e.target.name]: {
                value: e.target.value,
                error: false,
            },
        };

        this.setState(state);

        this.props.onChange(e.target.name, e.target.value, false);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps)(Component);
